import React from 'react'

import { Text } from '@wartek-id/text'

type TDescriptionCardProps = {
  title: string
  description?: string | React.ReactNode
}
const DescriptionCard = ({ title, description }: TDescriptionCardProps) => {
  const hasDescription = Boolean(description)
  return (
    <div className="mb-6">
      <Text variant="subheading" className="mb-3">
        {title}
      </Text>

      <Text
        variant="body"
        color={hasDescription ? 'default' : 'disabled'}
        className="mb-2 whitespace-pre-line break-words"
      >
        {hasDescription ? description : 'Belum diisi'}
      </Text>
    </div>
  )
}

export default DescriptionCard
